// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f6tUl","badges":"styles_badges__1B1nD"};